'use strict';

require('slick-carousel');
require('bootstrap-notify');

import $ from 'jquery';

var $document = $(document);
var $form = $('#js-product-form');
var $loader = $('#loader');
var $loaderSizes = $('#loader-sizes');
var $images = $('.js-product-images');
var $sizes = $('.js-product-sizes');
var $price = $('.js-product-price');
var $addButton = $('.js-add-button');
var $purchasableId = $('.js-purchasable-id');
//var $addToCart = $('.js-product-add');
var promise;

//load other color or size on form change
$loader.hide();
$loaderSizes.hide();
$('.js-price-disabled').hide();
slick();

$form.on('change', function (e) {

    $images.hide();
    $sizes.hide();
    $price.hide();
    $addButton.hide();
    $loader.show();
    $loaderSizes.show();
    onFormChange();

});

function onFormChange() {

    var url = '?' + $('#js-product-form input:radio').serialize();
    history.pushState('', 'New URL: ' + url, url);

    submitForm(url);
}

function submitForm(url) {

    if (promise) {
        promise.abort();
    }

    promise = $.get(url);
    promise.then(function (response) {

        $images.html($(response).find('.js-product-images').html());
        $sizes.html($(response).find('.js-product-sizes').html());
        $price.html($(response).find('.js-product-price').html());
        $addButton.html($(response).find('.js-add-button').html());
        $purchasableId.val($(response).find('.js-purchasable-id').val());
        $loader.hide();
        $loaderSizes.hide();
        $addButton.show();
        $images.fadeIn();
        $sizes.fadeIn();
        $price.fadeIn();

        // Reinit slick
        slick();

    }, function (error) {

    });

}

//slider images on product detail
function slick() {
    $('.js-slider--lrg').slick({
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        adaptiveHeight: true,
        asNavFor: '.slider--sml',
    });

    $('.js-slider--sml').slick({
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        centerMode: false,
        focusOnSelect: true,
        asNavFor: '.slider--lrg',
        responsive: [
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 660,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });
}

//update cart on click
$form.on('click', '.js-product-add', function (e) {
    e.preventDefault();
    updateCart(
        $(this),
        $(this).parents('form'),
        [
            'carticon',
        ]
    );
});

function updateCart($field, $form, replaceTypes) {
    if (typeof replaceTypes === 'undefined') {
        replaceTypes = [];
    }

    $field.parsley().reset();
    $field.parsley().validate();

    if (promise) {
        promise.abort();
    }

    var data = $form.serializeArray();
    data[window.csrfTokenName] = window.csrfTokenValue;

    promise = $.ajax({
        url: '',
        dataType: 'json',
        type: 'post',
        data: data,
        error: function (request, status, error) {
            var errorMessage = request.responseJSON.errors[Object.keys(request.responseJSON.errors)[0]][0];
            if (errorMessage) {
                $.notify({
                    // options
                    icon: 'icon icon--clear',
                    title: errorMessage,
                    url: '/cart',
                }, {
                    // settings
                    element: 'body',
                    position: null,
                    type: "error",
                    allow_dismiss: true,
                    newest_on_top: false,
                    showProgressbar: false,
                    placement: {
                        from: "top",
                        align: "right"
                    },
                    offset: 20,
                    spacing: 10,
                    z_index: 1031,
                    //delay: 5000,
                    timer: 1000,
                    mouse_over: null,
                    animate: {
                        enter: 'animated fadeInRight',
                        exit: 'animated fadeOutRight'
                    },
                    onShow: null,
                    onShown: null,
                    onClose: null,
                    onClosed: null,
                    icon_type: 'class',
                    template:   '<div data-notify="container" class="notice notice--danger alert-{0}" role="alert">' +
                        '<button type="button" aria-hidden="true" class="link close notice__close" data-notify="dismiss" style="border: none; background: none; outline: none;">× <span class="visuallyhidden">Close</span></button>' +
                        '<span data-notify="icon"></span> &nbsp; ' +
                        '<span data-notify="title">{1}</span> ' +
                        '<div class="progress" data-notify="progressbar">' +
                        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
                        '</div>' +
                        '<a href="{3}" data-notify="url"></a>' +
                        '</div>'
                });
            }
        }
    });

    promise.then(function (response) {

        if (typeof response.error !== 'undefined') {
            $field.parsley().addError('forcederror', {message: response.error, updateClass: true});
        } else {
            //notify when cart is updated
            $.notify({
                // options
                icon: 'icon icon--cart',
                title: 'Cart updated',
                url: '/cart',
            }, {
                // settings
                element: 'body',
                position: null,
                type: "info",
                allow_dismiss: true,
                newest_on_top: false,
                showProgressbar: false,
                placement: {
                    from: "top",
                    align: "right"
                },
                offset: 20,
                spacing: 10,
                z_index: 1031,
                //delay: 5000,
                timer: 1000,
                mouse_over: null,
                animate: {
                    enter: 'animated fadeInRight',
                    exit: 'animated fadeOutRight'
                },
                onShow: null,
                onShown: null,
                onClose: null,
                onClosed: null,
                icon_type: 'class',
                template:   '<div data-notify="container" class="notice notice--success alert-{0}" role="alert">' +
                                '<button type="button" aria-hidden="true" class="link close notice__close" data-notify="dismiss" style="border: none; background: none; outline: none;">× <span class="visuallyhidden">Close</span></button>' +
                                '<span data-notify="icon"></span> &nbsp; ' +
                                '<span data-notify="title">{1}</span> ' +
                                '<div class="progress" data-notify="progressbar">' +
                                    '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
                                '</div>' +
                                '<a href="{3}" data-notify="url"></a>' +
                            '</div>'
            });

            //replace items
            $.each(replaceTypes, function (index, value) {
                replaceContent(value, $field.data('id'));
            });
        }
    });
}

function replaceContent(type, id) {
    var request = $.get('/callback/' + type);

    request.then(function (html) {
        var $html = $(html);
        $document.find('.cart-' + type).html($html);
    }, function (error) {
        console.log(error);
    });
}
